import { container } from "assets/jss/material-kit-react.jsx";

const signupPageStyle = {
  container: {
    ...container,
    zIndex: "2",
    position: "relative",
    paddingTop: "20vh",
    color: "#FFFFFF",
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  dropZone:{
    width: "100%",
    display: "flex",
    height: 50,
    marginTop: 16,
    // marginBottom: 8,
    borderWidth: 2,
    borderColor: "rgb(102, 102, 102)",
    borderStyle: "dashed",
    borderRadius: 5,
    justifyContent: "center", /* align horizontal */
    alignItems: "center", /* align vertical */
  },
  acceptedFile: {
    borderColor: "rgb(102, 204, 102)",
    borderStyle: "solid"
  },
  rejectedFile: {
    borderColor: "rgb(204, 102, 102)",
    borderStyle: "solid",
  },
  pageHeader: {
    minHeight: "100vh",
    maxHeight: "1200px",
    height: "auto",
    display: "inherit",
    position: "relative",
    margin: "0",
    padding: "0",
    border: "0",
    alignItems: "center",
    "&:before": {
      background: "rgba(0, 0, 0, 0.5)"
    },
    "&:before,&:after": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: '""'
    },
    "& footer li a,& footer li a:hover,& footer li a:active": {
      color: "#FFFFFF"
    }
  },
  form: {
    margin: "0",
  },
  cardHeader: {
    width: "auto",
    textAlign: "center",
    marginLeft: "20px",
    marginRight: "20px",
    marginTop: "-40px",
    padding: "20px 0",
    marginBottom: "15px"
  },
  socialIcons: {
    maxWidth: "24px",
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px"
  },
  socialLoginContainer: {
    marginTop: "30px",
    marginBottom: "30px",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center"
  },
  divider: {
    marginTop: "0px",
    marginBottom: "0px",
    textAlign: "center",
    "& a": {
      color: "#0000ee",
    }
  },
  signupHelper: {
    fontSize: "12px",
    marginTop: "0px",
    marginBottom: "0px",
    textAlign: "center",
    fontStyle: "italic",
  },
  forgotPw: {
    marginTop: "0px",
    marginBottom: "0px",
    textAlign: "right",
    "& a": {
      color: "#0000ee",
    }
  },
  cardFooter: {
    paddingTop: "0rem",
    border: "0",
    borderRadius: "6px",
    justifyContent: "center !important"
  },
  addAnsBtns: {
    marginBottom: "0",
    // paddingBottom: "0",
  },
  rmvAnsBtns: {
    marginTop: "0",
    // paddingTop: "0",
  },
  socialLine: {
    marginTop: "1rem",
    textAlign: "center",
    padding: "0"
  },
  inputIconsColor: {
    color: "#495057"
  }
};

export default signupPageStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/loginPage.jsx